'use client'
import { CmsSellerFilters, CustomCmsSeller } from '../../../domain/seller'
import { useTranslation } from '../../context/ConfigContext'

import { ListSellersByType } from './ListSellersByType'

type ListSellersProps = {
  sellers: CustomCmsSeller[]
  onSelectStore: (seller: CustomCmsSeller) => void
  filters?: CmsSellerFilters
  selectedStore?: CustomCmsSeller
}

const ListSellers = ({ sellers, filters, selectedStore, onSelectStore }: ListSellersProps) => {
  const t = useTranslation()

  const messikaStores = sellers.filter((seller) => seller.isMessika)
  const resellers = sellers.filter((seller) => !seller.isMessika)

  return (
    <div className='map-list-sellers'>
      {!!messikaStores.length && (
        <ListSellersByType
          sellers={messikaStores}
          title={t("Messika's stores", {}, false)}
          filters={filters}
          selectedStore={selectedStore}
          onSelectStore={onSelectStore}
        />
      )}
      {!!resellers.length && (
        <ListSellersByType
          sellers={resellers}
          title={t('Revendeurs agréés', {}, false)}
          filters={filters}
          selectedStore={selectedStore}
          onSelectStore={onSelectStore}
        />
      )}
    </div>
  )
}

export default ListSellers
